/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './template-investigation.reducer';

export const TemplateInvestigationDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const templateInvestigationEntity = useAppSelector(state => state.templateInvestigation.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="templateInvestigationDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.templateInvestigation.detail.title">TemplateInvestigation</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.templateInvestigation.id">Id</Translate>
            </span>
          </dt>
          <dd>{templateInvestigationEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.templateInvestigation.active">Active</Translate>
            </span>
          </dt>
          <dd>{templateInvestigationEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.templateInvestigation.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{templateInvestigationEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.templateInvestigation.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{templateInvestigationEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.templateInvestigation.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{templateInvestigationEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.templateInvestigation.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{templateInvestigationEntity.timestampEntry}</dd>
          <dt>
            <span id="instructions">
              <Translate contentKey="tinyMedicRestApp.templateInvestigation.instructions">Instructions</Translate>
            </span>
          </dt>
          <dd>{templateInvestigationEntity.instructions}</dd>
          <dt>
            <span id="templateName">
              <Translate contentKey="tinyMedicRestApp.templateInvestigation.templateName">Template Name</Translate>
            </span>
          </dt>
          <dd>{templateInvestigationEntity.templateName}</dd>
          <dt>
            <span id="forSymptom">
              <Translate contentKey="tinyMedicRestApp.templateInvestigation.forSymptom">For Symptom</Translate>
            </span>
          </dt>
          <dd>{templateInvestigationEntity.forSymptom}</dd>
          <dt>
            <span id="templateItemType">
              <Translate contentKey="tinyMedicRestApp.templateInvestigation.templateItemType">Template Item Type</Translate>
            </span>
          </dt>
          <dd>{templateInvestigationEntity.templateItemType}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.templateInvestigation.imageTests">Image Tests</Translate>
          </dt>
          <dd>{templateInvestigationEntity.imageTests ? templateInvestigationEntity.imageTests.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.templateInvestigation.category">Category</Translate>
          </dt>
          <dd>{templateInvestigationEntity.category ? templateInvestigationEntity.category.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.templateInvestigation.item">Item</Translate>
          </dt>
          <dd>{templateInvestigationEntity.item ? templateInvestigationEntity.item.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.templateInvestigation.panel">Panel</Translate>
          </dt>
          <dd>{templateInvestigationEntity.panel ? templateInvestigationEntity.panel.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.templateInvestigation.prescription">Prescription</Translate>
          </dt>
          <dd>{templateInvestigationEntity.prescription ? templateInvestigationEntity.prescription.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/template-investigation" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/template-investigation/${templateInvestigationEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TemplateInvestigationDetail;
